module.exports = __webpack_public_path__ + "img/党员的义务.37288198.png";